var StringHelper = function() {

    function base64encode(str) {
        return btoa(unescape(encodeURIComponent(str)));
    }

    function base64decode(str) {
        return decodeURIComponent(escape(atob(str)));
    }

    function ucFirst(str) {
        return str.substring(0, 1).toUpperCase() + str.substring(1).toLowerCase();
    }

    function nl2br(str, is_xhtml) {
        if (typeof str === 'undefined' || str === null) {
            return '';
        }
        var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
        return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
    }

    function chunk_tel(str) {
        var tab = [];
        var num;

        for(i = 0, str.length; i < str.length; i += 2) {
        tab.push(str.substr(i, 2))
        }
        num = tab.join(' ');

        return num;
    };

    return {
        ucFirst: ucFirst,
        chunk_tel: chunk_tel,
        base64encode: base64encode,
        base64decode: base64decode,
        nl2br:nl2br
    };
}();
